import React, { useState } from 'react';

const SortByAlphabet = ({ onLetterClick }) => {
    const letters = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
    const [selectedLetter, setSelectedLetter] = useState('');

    const handleLetterClick = (letter) => {
        setSelectedLetter(letter);
        onLetterClick(letter);
    };

    return (
        <div className="w-full px-4 md:px-0">
            {/* Header Section: Stacks on mobile, side-by-side on desktop */}
            <div className='flex flex-col md:flex-row md:items-baseline gap-1 md:gap-4 mb-4'>
                <h2 className='text-[22px] md:text-[26px] text-[#101010] font-semibold leading-tight'>
                    Kidney Medicines
                </h2>
                <p className='text-[#606060] text-[14px] md:text-[16px]'>
                    Medicine Index starting with - <span className="font-bold text-[#14967F]">{selectedLetter || 'Select'}</span>
                </p>
            </div>

            {/* Alphabet Container: Scrollable with hidden scrollbar for a clean look */}
            <div className="flex overflow-x-auto pb-2 gap-2 scrollbar-hide focus:outline-none">
                {letters.map(letter => (
                    <button
                        key={letter}
                        onClick={() => handleLetterClick(letter)}
                        className={`flex-shrink-0 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg text-[15px] font-medium transition-all duration-200
                            ${letter === selectedLetter 
                                ? 'bg-[#14967F] text-white shadow-lg scale-105' 
                                : 'bg-[#F3F4F6] text-[#303030] hover:bg-[#e2e8f0]'}`}
                        aria-label={`Sort by letter ${letter}`}
                    >
                        {letter}
                    </button>
                ))}
            </div>
            
            {/* Simple CSS to hide scrollbar while keeping functionality */}
            <style dangerouslySetInnerHTML={{ __html: `
                .scrollbar-hide::-webkit-scrollbar { display: none; }
                .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
            `}} />
        </div>
    );
};

export default SortByAlphabet;